import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class EstShipping extends HTMLElement {
 connectedCallback() {
  const closestSection = this.closest('.shopify-section, dialog');
  if (!closestSection) return;
  closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateShipping);
}

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateShipping);
  }

  updateShipping = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newShipping = event.detail.data.html.querySelector('ie-pp-est-shipping [ref="shippingContainer"]');
    const currentShipping = this.querySelector('[ref="shippingContainer"]');

    if (!newShipping || !currentShipping) return;

    if (currentShipping.innerHTML !== newShipping.innerHTML) {
      currentShipping.replaceWith(newShipping);
    }
  };
}

if (!customElements.get('ie-pp-est-shipping')) {
  customElements.define('ie-pp-est-shipping', EstShipping);
}